export default "__VITE_ASSET__BcpxLGos__"